export default __webpack_public_path__ + "static/media/DarkBlue0005.f5301787.png";